import { render, staticRenderFns } from "./operateReview.vue?vue&type=template&id=655c639c&scoped=true&"
import script from "./operateReview.vue?vue&type=script&lang=js&"
export * from "./operateReview.vue?vue&type=script&lang=js&"
import style0 from "./operateReview.vue?vue&type=style&index=0&id=655c639c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655c639c",
  null
  
)

export default component.exports